// src/use-presence.ts
import {
  createSignal,
  useEffect
} from "@aria-ui/core";
function usePresence(element, open) {
  const visible = createSignal(open.peek());
  useEffect(element, () => {
    if (visible.get()) {
      show(element);
    } else {
      hide(element);
    }
  });
  useEffect(element, () => {
    if (open.get()) {
      visible.set(true);
      return;
    }
    const animations = element.getAnimations();
    if (animations.length === 0) {
      visible.set(false);
      return;
    }
    let canceled = false;
    Promise.allSettled(animations.map((animation) => animation.finished)).then(
      () => {
        if (!canceled) {
          visible.set(false);
        }
      }
    );
    return () => {
      canceled = true;
    };
  });
  return visible;
}
function show(element) {
  if (element.style.display === "none") {
    element.style.display = "";
  }
}
function hide(element) {
  element.style.display = "none";
}
export {
  usePresence
};
